export const HUB_SESSION_STORAGE_KEY = 'puppypad-hub';

export function getPersistedHubSession() {
  if (typeof window === 'undefined' || !window.localStorage) return null;

  try {
    const raw = window.localStorage.getItem(HUB_SESSION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state || null;
  } catch (error) {
    console.warn('[SESSION] Failed to read persisted Hub session:', error);
    clearPersistedHubSession();
    return null;
  }
}

export function getPersistedHubToken() {
  return getPersistedHubSession()?.token || null;
}

export function getPersistedHubUser() {
  return getPersistedHubSession()?.user || null;
}

export function clearPersistedHubSession() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.removeItem(HUB_SESSION_STORAGE_KEY);
  } catch (error) {
    console.warn('[SESSION] Failed to clear persisted Hub session:', error);
  }
}
